import ReactGA from "react-ga4";

export function trackWalletConnect(walletType: string | undefined, chainName: string | undefined): void {
  ReactGA.event("wallet_connect", { wallet_type: walletType, chain: chainName });
}

export function trackWalletConnectFailed(walletType: string | undefined, errorReason: string): void {
  ReactGA.event("wallet_connect_failed", { wallet_type: walletType, error_reason: errorReason });
}

export function trackKycStarted(provider: string): void {
  ReactGA.event("kyc_started", { provider });
}

const KYC_STATUS_TO_RESULT: Record<string, string> = {
  VERIFIED: "approved",
  REJECTED: "rejected",
  MANUAL_REVIEW: "manual_review",
};

export function trackKycCompleted(provider: string, status: string | undefined): void {
  const result = (status && KYC_STATUS_TO_RESULT[status]) || "pending";
  ReactGA.event("kyc_completed", { provider, result });
}
